(function () {
    angular.module('PWAPoCApp').factory('routeStopsLayerFactory', routeStopsLayerFactory);

    routeStopsLayerFactory.$inject = [
        '$q',
        '$state',
        '$rootScope',
        'esriLoader',
        'locationService',
        'mapService',
        'mapUtility',
        'routeStopsService'
    ];

    function routeStopsLayerFactory(
        $q,
        $state,
        $rootScope,
        esriLoader,
        locationService,
        mapService,
        mapUtility,
        routeStopsService
    ) {
        const defaultRouteStopCircleRadius = 25;

        let readyDeferred = null,
            currentPosition = null;

        let routeStopsLayerFactory = {
            createLayerOnAdd: true,

            ready: function () {
                if (readyDeferred === null) {
                    readyDeferred = $q.defer();
                }

                return readyDeferred.promise;
            }
        };

        esriLoader.require([
            'esri/Graphic',
            'esri/geometry/Point',
            'esri/geometry/Circle',
            'esri/geometry/SpatialReference',
            'esri/symbols/SimpleFillSymbol',
            'esri/layers/GraphicsLayer'
        ], function (
            Graphic,
            Point,
            Circle,
            SpatialReference,
            SimpleFillSymbol,
            GraphicsLayer
        ) {
            if (readyDeferred === null) {
                readyDeferred = $q.defer();
            }

            routeStopsLayerFactory.createLayer = function () {
                let routeStopsLayer = new GraphicsLayer();
                routeStopsLayer.zIndex = 3;
                routeStopsLayer.routeStops = [];
                routeStopsLayer.selectedRouteStops = [];
                routeStopsLayer.closestRouteStops = [];

                //Map event handler functions
                routeStopsLayer.onZoom = function (zoomLevel) {
                    var self = routeStopsLayer;
                    if (Number.isInteger(zoomLevel)) {
                        self.zoomLevel = zoomLevel;
                        routeStopsLayer.redrawLayer();
                    }
                };

                routeStopsLayer.onClick = function (evt, mapView, hitResponse) {
                    if (!hitResponse || hitResponse.results.length === 0) {
                        mapService.hidePopup();
                    } else {
                        let routeStopResults = hitResponse.results.filter(r =>
                            r.graphic.attributes
                            && r.graphic.attributes.routeLineId
                            && r.graphic.attributes.relatedObject);

                        if (routeStopResults.length > 0) {
                            let result = routeStopResults[0],
                                graphic = result.graphic;

                            if (graphic.attributes
                                && graphic.attributes.routeLineId
                                && graphic.attributes.relatedObject) {
                                mapService.showPopup(result.mapPoint, graphic.attributes.relatedObject.description);
                            }
                        }
                    }
                };

                //Draw functions
                routeStopsLayer.redrawLayer = function () {
                    let self = routeStopsLayer,
                        radius = getSize(self.zoomLevel);

                    let routeStopsGraphics = createRouteStopsGraphics(
                        self.routeStops,
                        self.selectedRouteStops.concat(self.closestRouteStops),
                        radius
                    );

                    self.removeAll();

                    self.addMany(routeStopsGraphics);
                };

                //Event handlers
                routeStopsLayer.handleUpdateClosestRouteStops = function (event, closestRouteStops) {
                    if (routeStopsLayer.selectedRouteStops.length !== closestRouteStops.length
                        || routeStopsLayer.selectedRouteStops.some(rs => !closestRouteStops.some(r => r.routeLineId === rs.routeLineId))) {

                        routeStopsLayer.closestRouteStops = closestRouteStops;
                        routeStopsLayer.redrawLayer();
                    }
                };

                /**
                 * Only single selection is allowed meaning selectionChangedEventParams can only contain
                 * at most one false and one true value.
                 */
                routeStopsLayer.handleRouteStopSelectionChanged = function (event, selectionChangedEventParams) {
                    const keys = Object.keys(selectionChangedEventParams);
                    keys.forEach(key => {
                        //Update selected route stops
                        let relatedRouteStop = routeStopsLayer.routeStops.find(rs => rs.routeLineId.toString() === key),
                            selectedRouteStopIdx = routeStopsLayer.selectedRouteStops.findIndex(rs => rs.routeLineId.toString() === key);

                        if (!selectionChangedEventParams[key]) {
                            if (selectedRouteStopIdx >= 0) {
                                routeStopsLayer.selectedRouteStops.splice(selectedRouteStopIdx, 1);
                            }
                        }

                        if (selectionChangedEventParams[key]) {
                            if (selectedRouteStopIdx === -1) {
                                routeStopsLayer.selectedRouteStops.push(relatedRouteStop);
                            }
                        }
                    });

                    if (keys.length > 0) {
                        routeStopsLayer.redrawLayer();
                    }
                };

                //Event subscriptions
                $rootScope.$on('updateClosestRouteStops', routeStopsLayer.handleUpdateClosestRouteStops);
                $rootScope.$on('routeStopSelectionChanged', routeStopsLayer.handleRouteStopSelectionChanged);

                locationService
                    .getCurrentPosition()
                    .then(position => {
                        currentPosition = position;
                    }).then(() => {
                        if ($state.params.orderId && currentPosition) {
                            var isAjour = $rootScope.userType === 'ajour';
                            routeStopsService
                                .getRoute(
                                    $state.params.orderId,
                                    currentPosition,
                                    isAjour
                                )
                                .then((route => {
                                    if (routeStopsLayer.routeStops.length === 0) {
                                        routeStopsLayer.routeStops = route.routeStops;
                                    }

                                    var routeStopsGraphics = createRouteStopsGraphics(
                                        routeStopsLayer.routeStops,
                                        routeStopsLayer.selectedRouteStops,
                                        getSize(13)
                                    );
                                    routeStopsLayer.addMany(routeStopsGraphics);
                                }));
                        }
                    });

                return routeStopsLayer;
            };

            function createRouteStopsGraphics(routeStops, selectedStops, radius) {
                let routeStopsGraphics = [],
                    currentRadius = radius ? radius : defaultRouteStopCircleRadius;

                for (let i = 0; i < routeStops.length; ++i) {
                    let isSelected = selectedStops.some(rs => rs.routeLineId === routeStops[i].routeLineId);
                    let routeStopGraphic = createRouteStopGraphic(routeStops[i], isSelected, currentRadius);
                    routeStopsGraphics.push(routeStopGraphic);
                }

                return routeStopsGraphics;
            }

            function createRouteStopGraphic(routeStop, isSelected, radius) {
                let point = createRouteStopPoint(routeStop, 4326);
                let routeStopColor = getRouteStopColor(routeStop);

                let fillSymbol = new SimpleFillSymbol({
                    color: routeStopColor,
                    style: 'solid',
                    outline: {
                        color: routeStopColor,
                        width: 0.1
                    }
                });

                if (isSelected) {
                    fillSymbol.outline = {
                        color: '#333333',
                        width: 4
                    };
                }

                let routeStopGraphic = createCircleGraphic(point, radius, fillSymbol);

                routeStopGraphic.attributes = {
                    routeLineId: routeStop.routeLineId,
                    relatedObject: routeStop
                };

                return routeStopGraphic;
            }

            function createCircleGraphic(point, radius, fillSymbol) {
                let circle = new Circle({
                    center: point,
                    radius: radius
                });

                return new Graphic(circle, fillSymbol);
            }

            function createRouteStopPoint(routeStop, wkid) {
                let x = routeStop.longitude,
                    y = routeStop.latitude;

                if (wkid === 4326) {
                    let convertedCoords = mapUtility.convertToUTM33N(y, x);
                    x = convertedCoords.X;
                    y = convertedCoords.Y;
                }

                return new Point({
                    x: x,
                    y: y,
                    spatialReference: new SpatialReference({ wkid: 32633 })
                });
            }

            function getRouteStopColor(routeStop) {
                if (routeStop.status !== 'uncompleted') return '#02ac4a';

                var lowerCaseWasteType = routeStop.wasteType
                    ? routeStop.wasteType.toLowerCase()
                    : 'pr';
                switch (lowerCaseWasteType) {
                    case 'pr':
                        return '#eb0000';
                    case 'næ':
                        return '#0000eb';
                    case 'sl':
                        return '#914e82';
                    default:
                        return '#eb0000';
                }
            }

            function getSize(zoom) {
                let sizeArray = [
                    25,
                    25,
                    25,
                    25, //5
                    20,
                    20,
                    20,
                    20,
                    20, //10
                    16,
                    14,
                    12, //13
                    10,
                    8, //15
                    6,
                    4, //17 - max zoom
                    4,
                    4,
                    4 //20
                ];

                let size = sizeArray.length >= zoom ? sizeArray[zoom - 1] : defaultRouteStopCircleRadius;
                return size;
            }

            readyDeferred.resolve(routeStopsLayerFactory);
        });

        return routeStopsLayerFactory;
    }
})();
